// extracted by mini-css-extract-plugin
export default {"swiper":"Gift_swiper__iJ6Q8","swiper-slide":"Gift_swiper-slide__5jcGc","mySwiper":"Gift_mySwiper__LwWpB"};